BaseModel = require('base/model')

class HeaderModel extends BaseModel

module.exports = HeaderModel
